import type React from "react";
import {observer} from "mobx-react-lite";
import {TablePagination} from "@mui/material";
import {useStores} from "../../../../../../stores";

type Props = {
    row_id: string | number,
}
export const SubGroupPaginationCell: React.FC<Props> = observer(({row_id}) => {
    const {categorizationReviewStore} = useStores();
    const controller = categorizationReviewStore.reviewPageController.reviewPageTableController;

    return <TablePagination
        component="div"
        className="sub-group-pagination"
        disabled={controller.getGroupDisabled(row_id)}
        showFirstButton
        showLastButton
        count={controller.getGroupPageCount(row_id)}
        page={controller.getGroupPage(row_id)}
        rowsPerPage={controller.getGroupPerPage(row_id)}
        onPageChange={(e, page) => {
            controller.updateGroupPage(row_id, page);
        }}
        onRowsPerPageChange={(e) => {
            controller.updateGroupPerPage(row_id, Number(e.target.value));
        }}
    />;
});
